import axiosInstance from "../utils/axios";

const BASE_URL = "/cms/v1";

async function getActivityCalculatorComponent(merchantCode: string) {
  return axiosInstance.get(`${BASE_URL}/components/journey-calculator`, {
    params: { merchantCode }
  })
}

export {
  getActivityCalculatorComponent,
}